import React, { useContext, useState } from 'react';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import whitelogo from '../../assets/img/logo.png';
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';

import HelpMenu from '../helpMenuAdmin';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import { styled, useTheme } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { useDispatch } from "react-redux";
import {
    Navigate,
    Link,
    NavLink,
    useNavigate,
    useParams,
    useLocation
  } from "react-router-dom";

import { AppContext } from '../../context';
import  secureLocalStorage  from  "react-secure-storage";
import {logout as logoutAction} from '../../actions/admin.actions';
import { holdUser, logout } from "../../features/userdataSlice";
import DownloadIcon from '@mui/icons-material/Download';


const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

function SidebarAdmin () {
    const { pathname } = useLocation();
  const dispatch = useDispatch();
    const theme = useTheme();
    const [open, setOpen] = React.useState(true);
    const handlelogout = (e) => {
        logoutAction()
        .then((res) => {
            if(res.data.status){
                dispatch(logout());
                console.log("logout");
                navigate(`/`);
            }
        }).catch((err) => {
            console.log(err);
        });

    }
    const handleDrawerOpen = () => {
      setOpen(true);
    };
  
    const handleDrawerClose = () => {
      setOpen(true);
    };
    let navigate = useNavigate();
    const [activemenu, setActivemenu] = React.useState(false);
   

    const handleClick = (link) => () => {

    
   
        setActivemenu(link);
       
          navigate(`${link}`);
          
          // setActivemenu(); 
      };




    const rootMenus = [
        
        {
          name: 'User Management',
          link: "/admin/usermanagement",
          
         
        },
        // {
        //   name: 'Location Management',
        //   link: "/admin/addlocation",
         
        // },
        {
          name: 'Student Management',
          link: "/admin/studentmanagement",
          
        },
        {
            name: 'Application List',
            link: "/admin/applicationlist",
           
          },
          {
            name: 'Impersonate',
            link: "/admin/impersonate",
           
          },
          // {
          //   name: 'Report',
          //   link: "/admin/report",
           
          // },
         
       
    
      ];

      React.useEffect(() => {
        if(pathname === '/admin/adduser'  || pathname === '/admin/manageuser' || pathname === '/admin/usermanagement'){
          setActivemenu('/admin/usermanagement');
        }
        else if(pathname === '/admin/addlocation' || pathname === '/admin/managelocation'){
          setActivemenu('/admin/addlocation');
        }
    
        else if(pathname === '/admin/studentmanagement' || pathname === '/admin/studentdetails' || pathname === '/admin/editstudentdetails'){
          setActivemenu('/admin/studentmanagement');
        }

        else if(pathname === '/admin/applicationlist'){
          setActivemenu('/admin/applicationlist');
        }
        else if(pathname === '/admin/impersonate'){
          setActivemenu('/admin/impersonate');
        }
        
        else if(pathname === '/admin/report'){
          setActivemenu('/admin/report');
        }
       
       
        
        else{
          setActivemenu(pathname);
        }


      }, []);

   



  return (
    <>
    <CssBaseline />
    <AppBar position="fixed" open={open} className='headeradmnsec'>
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
          edge="start"
          sx={{
            marginRight: 5,
            ...(open && { display: 'none' }),
          }}
        >
          <MenuIcon />
        </IconButton>
        <Typography variant="h6" noWrap component="div" className='mid-adm-sec'>
     
              <div className='headr-adm-sec'>
              <div className='container-fluid'>
                <div className='row'>
                  <div className='col-md-12'>
                    <div className='regis-header'>
                      <div className='adm-regis-header regis-header athe-right'>
                        <ul>
                          <li> <HelpMenu /></li>
                          <li><a><PersonIcon /> Admin
                         </a></li>
                          <li className='logt-sec' role='button' onClick={handlelogout} ><span className='content-sec'>Logout</span><LogoutIcon /></li>
                        </ul>
                      </div>
                      </div>

                    </div>
                </div>
              </div>
              </div>
        </Typography>
      </Toolbar>
    </AppBar>
   

<Drawer variant="permanent" open={open} className='drawer-main-sec'>
      <DrawerHeader className='drwhead'>
      <div className='athe-img ad-heth-log'>
              <Link to="#"> <img src={whitelogo} alt='logo' className='logo' /></Link>
            <p>Version 1.5</p>
              </div>
       {/* <IconButton onClick={handleDrawerClose}>
          {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </IconButton>*/}
       
      </DrawerHeader>
 
      <Divider />
      <List>
     
        {rootMenus.map(({ name, link }, index) => (
    

        <React.Fragment key={index} >
        <ListItem 
onClick={handleClick(link)}
selected={(link === activemenu )}
   
        >

          <ListItemIcon title={name}

          >


            {name == 'User Management' && <PersonIcon />}

            {name == 'Location Management' && <LocationOnIcon />}
       
            {name == 'Student Management' && <PersonIcon />}

            {name == 'Application List' && <InsertDriveFileIcon />}
            {name == 'Impersonate' && <ManageAccountsIcon />}
            {name == 'Report' && <DownloadIcon />}

            
         
          </ListItemIcon>

          <ListItemText primary={name} />

         


        </ListItem>
       

      </React.Fragment>
        ))}
      </List>
     
    </Drawer>
    </>
  )
}

export default SidebarAdmin;
